<template>
  <div styleName="player_box" :style="playerBoxHeight"></div>
</template>

<script>
  export default {
    data () {
      return {
        height: 42
      }
    },
    computed: {
      playerBoxHeight () {
        return `height: ${this.height}px`
      }
    },
    mounted () {
      this.$eventSource.addListener('playerBoxChange', height => {
        this.height = height
      })
    }
  }
</script>

<style module>
  .player_box {
    width: 320px;
  }
</style>
